import { ContainerModule, interfaces, Container } from 'inversify';
import {
    ClientTypes,
    IGeneratedSettings as ISettings,
    IContextKeyService,
    IEditorService,
    IModelService,
    IModeService,
    ICodeEditorService,
    IClientConfigurationService as IConfigurationService,
    ILifecycleService,
    IJSONEditingService,
    IClientWorkspaceContextService as IWorkspaceContextService,
    IEnvironmentService, ITextResourceConfigurationService, INotificationsService,
    IDialogService, IKeybindingService, IKeymapService, IQuickInputService,
    IStorageService, ICommandService, IKeybindingEditingService, IStatusbarService, IContextMenuService,
} from '@workbench-stack/core';
import { CodeEditorService, ModelService, ModeService, ResourceContextKey, ConfigurationService,
    LifecycleService, JSONEditingService, WorkspaceContextService, TextResourceConfigurationService, NotificationService,
    DialogService, EnvironmentClientService, WorkbenchKeybindingService, BrowserKeymapService, ContextMenuService,
    TextModelResolverService, StorageService, CommandService, KeybindingsEditingService, StatusbarService,
    QuickInputService,
} from '../services';
import { ContextKeyService } from '@workbench-stack/platform-browser/lib/services/context-key/context-key-service';
import { ITextModelService } from '@vscode-alt/monaco-editor/esm/vs/editor/common/services/resolverService';

export const workbenchModule: () => interfaces.ContainerModule =
    () => new ContainerModule((bind: interfaces.Bind) => {

        bind<ITextModelService>(ClientTypes.ITextModelService).to(TextModelResolverService).inSingletonScope();
        bind<ICodeEditorService>(ClientTypes.ICodeEditorService).to(CodeEditorService).inSingletonScope();
        bind<IModelService>(ClientTypes.IModelService).to(ModelService).inSingletonScope();
        bind<IModeService>(ClientTypes.IModeService).to(ModeService).inSingletonScope();
        bind<IContextKeyService>(ClientTypes.IContextKeyService).to(ContextKeyService).inSingletonScope();

        bind<ResourceContextKey>(ClientTypes.IResourceContextKey).to(ResourceContextKey).inSingletonScope();

        bind<IConfigurationService>(ClientTypes.IConfigurationService).to(ConfigurationService).inSingletonScope();

        bind<ILifecycleService>(ClientTypes.ILifecycleService).to(LifecycleService).inSingletonScope();

        bind<IJSONEditingService>(ClientTypes.IJSONEditingService).to(JSONEditingService).inSingletonScope();

        bind<IWorkspaceContextService>(ClientTypes.IWorkspaceContextService).to(WorkspaceContextService).inSingletonScope();

        bind<IEnvironmentService>(ClientTypes.IEnvironmentService).to(EnvironmentClientService).inSingletonScope();

        bind<INotificationsService>(ClientTypes.INotificationService).to(NotificationService).inSingletonScope();

        bind<IDialogService>(ClientTypes.IDialogService).to(DialogService).inSingletonScope();

        bind<IStatusbarService>(ClientTypes.IStatusbarService).to(StatusbarService).inSingletonScope();
        bind<IKeybindingService>(ClientTypes.IKeybindingService).to(WorkbenchKeybindingService).inSingletonScope();

        bind<IKeybindingEditingService>(ClientTypes.IKeybindingEditingService).to(KeybindingsEditingService).inSingletonScope();

        bind<IKeymapService>(ClientTypes.IKeymapService).to(BrowserKeymapService).inSingletonScope();

        bind<IContextMenuService>(ClientTypes.IContextMenuService).to(ContextMenuService).inSingletonScope();

        bind<IQuickInputService>(ClientTypes.IQuickInputService).to(QuickInputService).inSingletonScope();

        // bind<IStorageService>(ClientTypes.IStorageService).to(StorageService).inSingletonScope();

        bind<ICommandService>(ClientTypes.ICommandService).to(CommandService).inSingletonScope();

        bind<ITextResourceConfigurationService>(ClientTypes.ITextResourceConfigurationService).to(TextResourceConfigurationService).inSingletonScope();
        bind<interfaces.Container>('Container').toDynamicValue((context: interfaces.Context) => {
            const childContainer = new Container();
            childContainer.parent = context.container;
            return childContainer;
        });
    });
